import { getFormDataFiles, getUploadQueryParams } from "../utils/utils";
import { post, remove } from "./http.service";

const uploadService = {
  add: body => post(`upload`, getFormDataFiles(body)),
  remove: files => remove(`upload${getUploadQueryParams(files)}`),
};

export default uploadService;
